import { render } from "./InfoRowDetailsPromReport.vue?vue&type=template&id=35c97c90&scoped=true"
import script from "./InfoRowDetailsPromReport.vue?vue&type=script&lang=js"
export * from "./InfoRowDetailsPromReport.vue?vue&type=script&lang=js"

import "./InfoRowDetailsPromReport.vue?vue&type=style&index=0&id=35c97c90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c97c90"]])

export default __exports__